module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "choice-character"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Choisissez votre joueur")]), _vm._v(" "), (_vm.players) ? _c('ul', _vm._l((_vm.players), function(player, i) {
    return _c('li', {
      staticClass: "choice-character__single",
      attrs: {
        "data-player": player.name,
        "data-pos": i
      },
      on: {
        "click": _vm.choiceCharacter
      }
    }, [_c('img', {
      attrs: {
        "src": player.img,
        "alt": player.name
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(player.name))])])
  })) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.getCharactersData))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60f62dee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/choice-character/ChoiceCharacter.vue
// module id = 86
// module chunks = 0